const productTotalPriceButton = document.querySelector('.product .product-form__submit #total-price');
const productQuantity = document.querySelector('.product quantity-input');
const productQuantityButtons = document.querySelectorAll('button')
const productQuantityInput = productQuantity.querySelector('input');

let productTotalPrice = 0;

function numberToEuro(number){
    const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
    return euroValue;
}

function updateProductTotalPrice(){
    productTotalPrice = parseInt(productTotalPriceButton.dataset.productPrice)*parseInt(productQuantityInput.value);
    productTotalPriceButton.textContent = `${numberToEuro(productTotalPrice)}`;
}
updateProductTotalPrice();

productQuantityButtons.forEach(btn => {
    btn.addEventListener('click', () => {
        updateProductTotalPrice();
    })
})